export const environment = {
  production: false,
  environmentName: 'qa',
  url: 'https://enova-qa-ag.vanti.tech',
  base_url: 'https://enova-qa-ag.vanti.tech/',
  prediction_url: 'https://enova-qa-ag.vanti.tech/prediccion/',
  admin_url: 'https://enova-qa-ag.vanti.tech/administracion/',
  consumption_url: 'https://enova-qa-ag.vanti.tech/consumos/',
  sso: {
    appId: '68757a72511339a0466e2c45',
    url: 'https://iam-qa.vanti.tech/login?app_id=68757a72511339a0466e2c45',
  },
  datadog: {
    clientToken: 'pub35b3ded58326e472e56c8b89a87987fe',
    applicationId: '6bfef076-c3b4-4874-b2fc-aac0fe1cb69a',
    site: 'datadoghq.com',
    service: 'nominaciones',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
  },
};
